export default __webpack_public_path__ + "static/media/newyear8.b87e4b00.png";